import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { ConfirmDialog, useToast, Alert, Typography } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { useHistory } from 'react-router-dom';
import { useDeleteUser } from 'app/domains/users/hooks/useDeleteUser';
export function ConfirmDeleteUserDialog(props) {
    const { id, name, onClose, navigateTo } = props;
    const [deleteUser, { loading, error }] = useDeleteUser(id);
    const { addToast } = useToast();
    const history = useHistory();
    const fallbackName = t({
        message: 'Unknown',
        comment: 'Fallback name when user does not exist',
    });
    const username = name || fallbackName;
    const handleConfirm = () => {
        deleteUser()
            .then(() => {
            addToast({
                title: t({ message: 'User deleted', comment: 'Success toast message delete user' }),
                appearance: 'success',
            });
            onClose();
            if (navigateTo) {
                history.push(navigateTo);
            }
        })
            .catch(() => {
            addToast({
                title: t({
                    message: 'Something went wrong, please try again later',
                    comment: 'Error alert message delete user',
                }),
                appearance: 'danger',
            });
        });
    };
    return (<ConfirmDialog appearance="danger" size="sm" loading={loading} icon={<Falcon icon="triangle-exclamation"/>} title={t({ message: 'Delete user', comment: 'Delete user dialog - title' })} confirm={t({ message: 'Delete', comment: 'Delete user dialog - confirm button' })} cancel={t({ message: 'Cancel', comment: 'Delete user dialog - cancel button' })} onConfirm={handleConfirm} onCancel={onClose} onClose={onClose}>
      <Typography>
        <Trans comment="Delete user dialog - message">
          You are about to delete <b>{username}</b>. Their personal information will be permanently deleted. Any content
          created by the said user will remain on Pocketlaw.
        </Trans>
      </Typography>
      {error && (<Alert appearance="danger" message={t({
                message: 'Something went wrong, please try again later',
                comment: 'error alert message delete user',
            })}/>)}
    </ConfirmDialog>);
}
